<template>
  <b-container fluid class="d-flex flex-column justify-content-between py-3">
    <b-row>
      <b-col cols="12" class="pb-3">
        <b-form-input
          v-model="termId"
          placeholder="端末IDを入力します"
          ref="termIdInput"
          type="text"
          :disabled="disabledInput"
        ></b-form-input>
      </b-col>
      <b-col cols="12" class="pb-3">
        <b-form-input
          v-model="serverUrl"
          placeholder="接続先サーバーを入力します"
          ref="serverUrlInput"
          type="text"
          :disabled="disabledInput"
        ></b-form-input>
      </b-col>
      <b-col cols="12" class="pb-3">
        <b-form-input
          v-model="codeTypes"
          placeholder="スキャンコード種を「|」区切りで入力します"
          ref="codeTypesInput"
          type="text"
          :disabled="disabledInput"
        ></b-form-input>
      </b-col>
      <b-col cols="12">
        <b-button block pill variant="primary" @click="onClickRegister">登録</b-button>
      </b-col>
      <!-- <b-col cols="12">
        <b-button block pill variant="primary" @click="onClickCancel">解除</b-button>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col>
        <!-- <img src="@/assets/logo.png" fluid alt="ロゴ" class="w-100" /> -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { postTerminalAPI } from '@/api';
import { setTerminalInfo } from '@/lib/kjs-wrapper';
import { inputMode } from '@/constants';

export default {
  name: 'RegisterTerminal',
  data() {
    return {
      termId: null, // 端末ID
      serverUrl: null, // サーバーURL
      codeTypes: null, // コード種リスト
      selectedInputMode: null // 選択中入力モード
    };
  },
  mounted() {
    // 画面を初期化
    this.$emit('initView', {
      viewId: null, // 画面ID
      useToolButtons: true, // ツールボタン使用
      defaultInputMode: inputMode.BARCODE, // デフォルトバーコード入力
      usableInputModeBits: inputMode.BARCODE + inputMode.KEY // バーコード＋手入力
    });

    this.$emit('enabledScan', true);
  },
  computed: {
    disabledInput: function () {
      return this.selectedInputMode !== inputMode.KEY;
    }
  },
  methods: {
    /**
     * 入力モード変更処理(親コンポーネントより)
     * @param {string} mode 入力モード(1:手入力、2:OCR、4:バーコード)
     */
    changeInputMode: function (mode) {
      this.selectedInputMode = mode;
      if (mode === inputMode.BARCODE) {
        this.$store.commit('setMessage', '端末情報を読取します');
      } else {
        this.$store.commit('setMessage', '端末情報を入力します');
        if (this.termId) this.$refs.serverUrlInput.focus();
        else this.$refs.termIdInput.focus();
      }
    },
    /**
     * 入力クリア(親コンポーネントより)
     */
    clearInput: function () {
      this.termId = null;
      this.serverUrl = null;
      this.codeTypes = null;
      this.$store.commit('setMessage', null);
    },
    /**
     * スキャンデータ解析後(親コンポーネントより)
     * @param {string} スキャン生データ
     * @param {array} 明細値配列
     * @param {object} barcode 対象バーコード
     * @param {string} dupType 重複区分(1:重複OK、2:重複NG)
     * @returns {boolean} スキャンデータ反映成否
     */
    analyzedScanData: function (headerValue, detailValues, barcode, dupType) {
      // カンマ区切りで分割してセット
      const termInfos = headerValue.split(',');
      this.termId = termInfos.length > 0 ? termInfos[0] : null;
      this.serverUrl = termInfos.length > 1 ? termInfos[1] : null;
      this.codeTypes = termInfos.length > 2 ? termInfos[2] : null;

      // 端末登録処理へ
      this.onClickRegister();

      return true;
    },
    /**
     * 登録ボタン
     */
    onClickRegister: async function () {
      this.$store.commit('setMessage', null);

      // 入力チェック
      if (!this.termId || !this.serverUrl) {
        this.changeInputMode(this.selectedInputMode);
        return;
      }

      // 端末情報登録
      if (this.codeTypes) {
        const ret = await postTerminalAPI(this.termId, this.serverUrl);
        if (!ret) {
          this.$store.commit('setMessage', '通信エラー(端末情報登録)');
          return;
        }
        if (!ret.data.terminalId) {
          this.$store.commit('setMessage', '既に他の端末で使用されています');
          return;
        }
      }

      // 端末情報ファイルセット
      setTerminalInfo({
        termId: this.termId,
        serverUrl: this.serverUrl,
        codeTypes: this.codeTypes
      });

      // ログイン画面へ
      if (this.codeTypes) this.$router.replace({ path: '/UserLogin' });
      else this.$router.replace({ path: '/ExportHistory' });
    },
    onClickCancel: function () {
      this.$store.commit('setMessage', null);
    }
  }
};
</script>

<style>
div.container-fluid {
  height: 100%;
}
</style>
